export default function Contato() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  return (
    <div className="fixed top-auto left-auto bottom-4 right-4 z-30">
      <button onClick={scrollToTop} type="button" className="md:hidden">
        <img src="../assets/top-button.svg" alt="" className="size-16" />
      </button>
    </div>
  )
}
